import * as React from 'react';
import set from 'lodash/set';
import get from 'lodash/get';
import { columnName, tableName } from 'app/area/case/case-data-model';

export function caseEgressReadonly<P extends object>() {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<P>) => {

    return class extends React.PureComponent<P> {
      public render() {
        const {
          readOnly,
          currentUser,
          rowEntity
        } = this.props as any;

        let readOnlyOverride = undefined;
        const modifiedProps: P = {...this.props as any};
        const rowUser = get(rowEntity, `${columnName[tableName.involvedPersonInside].egressTimeRecordedBy}[0].value`);

        // user > 0, but not current user on row
        if(rowUser && rowUser !== currentUser?.value){
          readOnlyOverride = true;
        }

        // domain criteria, typically effect of beeing a case administrator
        if(readOnly === false) {
          readOnlyOverride = false;
        }

        if (readOnlyOverride !== undefined) {
          set(modifiedProps as P, 'readOnly', readOnlyOverride);
        }

        return <WrappedComponent { ...modifiedProps } /> ;
      }
    };
  };
}
